export default "__VITE_ASSET__biBdS$vB__"